export const ROUTES_URL = Object.freeze({
    HOME: "/life_plans/*"
});